import { render, staticRenderFns } from "./SchedulePickups.vue?vue&type=template&id=72d796e4&"
import script from "./SchedulePickups.vue?vue&type=script&lang=js&"
export * from "./SchedulePickups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports